<template>
  <mcs-btn
    v-if="show"
    color="black"
    :outlined="!mobile"
    :icon="mobile"
    class="mr-3 px-4 bg-white"
    prependIcon="mdi-account-group"
    @click="click"
  >
    {{ mobile ? '' : 'Invite' }}
  </mcs-btn>
</template>

<script>
import { DRAWERS, ROUTES } from '@/utils/constants';
import { mapGetters } from 'vuex';

export default {
  name: 'InviteButton',

  data() {
    return {};
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    show() {
      if (this.$route.name === ROUTES.PROJECT_DETAIL.NAME) {
        return false;
      }
      if (this.enableApi && !this.isMCS) {
        return false;
      }
      if (this.isMasterAccountOwner) {
        return true;
      }
      if (this.collections_to_manage_people.length) {
        return true;
      }
      if (this.isMCS && !this.collections.length) {
        return true;
      }
      return false;
    },
    ...mapGetters({
      isMasterAccountOwner: 'user/isMasterAccountOwner',
      collections_to_manage_people: 'user/collections_to_manage_people',
      collections: 'user/collections',
      isMCS: 'user/isMCS',
      enableApi: 'user/enableApi'
    })
  },

  methods: {
    click() {
      if (this.isMasterAccountOwner || this.collections_to_manage_people.length) {
        this.$store.commit('drawers/OPEN_DRAWER', DRAWERS.ADD_PEOPLE);
      } else {
        this.$store.commit('drawers/SET_DATA', {
          drawerId: DRAWERS.ADD_PEOPLE,
          data: { createCollection: true }
        });
        this.$store.commit('drawers/OPEN_DRAWER', DRAWERS.ADD_PEOPLE);
      }
    }
  }
};
</script>

<style></style>
